import { css } from 'aphrodite';
import moment from 'moment';
import * as React from 'react';
import { CoffeeLeadIssueCategory, ICoffeeLeadIssueView } from '../../../../../extViewmodels';
import { Checkbox } from '../../../../../web/components-v2/Checkbox';
import { Label } from '../../../../../web/components-v2/Label';
import { linkifyText } from '../../../../../models/UxUtils';
import { LeadServedSource } from '../../../../viewModels/queue';
import { styleSheet } from '../styles';

const CategoryLabels: Record<CoffeeLeadIssueCategory, string> = {
	[CoffeeLeadIssueCategory.WrongLocationOrTimeZone]: 'Wrong Location/Timezone',
	[CoffeeLeadIssueCategory.Duplicate]: 'Duplicate',
	[CoffeeLeadIssueCategory.CurrentClientNeedsAttention]: 'Current Client Needs Attention',
	[CoffeeLeadIssueCategory.Other]: 'Other',
};

interface IProps {
	item: ICoffeeLeadIssueView;
	onMarkComplete?: (issueId: string) => void;
}

export const ListItem: React.FC<IProps> = ({ item, onMarkComplete }) => {
	const handleChangeComplete = () => onMarkComplete?.(item.id);

	const date = item.creationDate ? moment(item.creationDate).format('h:mma MMM D') : 'Unknown';
	const isComplete = !!item.completionDate;
	const reporterName = item.reporter ? `${item.reporter.firstName} ${item.reporter.lastName}` : 'Unknown';
	const checkboxId = `complete-issue-${item.id}`;
	const leadUrl = item.companyId
		? `${window.location.origin}/#/queue?from=${LeadServedSource.SharedLink}&companyId=${item.companyId}`
		: null;

	return (
		<div className={css(styleSheet.listItem)}>
			<div className={css(styleSheet.card)}>
				<div className={css(styleSheet.cardHeader)}>
					<span className={css(styleSheet.cardHeaderTitle)}>
						{reporterName} &mdash; {date}
					</span>
					<div className={css(styleSheet.cardHeaderRight)}>
						{isComplete && (
							<span className={css(styleSheet.completedInfo)}>
								{moment(item.completionDate).format('MM/DD/YYYY')}
								{item.completedBy && ` — ${item.completedBy.firstName} ${item.completedBy.lastName}`}
							</span>
						)}
						<Label
							htmlFor={checkboxId}
							styles={[styleSheet.completeLabel, isComplete ? styleSheet.completeLabelDone : null]}
						>
							<Checkbox
								id={checkboxId}
								checked={isComplete}
								disabled={isComplete}
								onCheckedChange={isComplete ? undefined : handleChangeComplete}
							/>
							Complete
						</Label>
					</div>
				</div>
				<div className={css(styleSheet.cardBody, styleSheet.cardText)}>
					<div>
						<div className={css(styleSheet.cardColumnTitle)}>LEAD</div>
						{leadUrl ? (
							<a className={css(styleSheet.leadLink)} href={leadUrl} target='_blank' rel='noreferrer'>
								{item.companyName || 'Unknown'}
							</a>
						) : (
							item.companyName || 'Unknown'
						)}
					</div>
					<div>
						<div className={css(styleSheet.cardColumnTitle)}>CATEGORY</div>
						{CategoryLabels[item.category] || item.category}
					</div>
					<div>
						<div className={css(styleSheet.cardColumnTitle)}>DESCRIPTION</div>
						<div className={css(styleSheet.cardDescription)}>{linkifyText(item.description)}</div>
					</div>
				</div>
			</div>
		</div>
	);
};
